// Class used to "Hydrate" the react APP after the server rendering
import React from 'react'
import { createRoot } from 'react-dom/client'
import { hydrateRoot } from 'react-dom/client'
import App from './client/app.jsx'

import mockedData from './e2e/mockData/SERPProductSiteData.json'

/* istanbul ignore next */

// This "if" decides how to initialize React. SSR or "Client Only"
/* istanbul ignore next */
if (!window.__INITIAL_DATA) {
    // Client Only React
    const root = createRoot(document.getElementById('SNAPS2_root'))
    root.render(
        <React.StrictMode>
            {/* We need to send the same data that the server would like to keep in sync */}
            <App {...mockedData} />
        </React.StrictMode>
    )
} else {
    // SSR React
    hydrateRoot(
        document.getElementById('SNAPS2_root'),
        <React.StrictMode>
            <App {...window.__INITIAL_DATA} />
        </React.StrictMode>
    )
}
